import { googleAnalytics } from "../gtag";

export function loginCapture(data) {
  googleAnalytics("event", "login", {
    method: data.method,
  });
}
